<i18n locale="en">
{
  "label": "Max"
}
</i18n>
<template>
  <span class="upsell-plan-badge" data-testid="upsell-plan-badge">
    <PlusSmall :size="12" />
    <OwnType
      :text="text ?? t('label')"
      variant="title-very-small"
      color="inherit"
    />
  </span>
</template>

<script lang="ts" setup>
import { PlusSmall } from '@owner/icons-vue/PlusSmall'
import { useI18n } from 'vue-i18n'

import { OwnType } from '@/ui/OwnType'

withDefaults(
  defineProps<{
    text?: string
  }>(),
  {
    text: undefined,
  }
)

const { t } = useI18n()
</script>

<style lang="scss" scoped>
// Max-plan purple from the tier-upgrades design — not yet in the Hermes token
// palette.
.upsell-plan-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 8px;
  color: #7a3a9b;
  background-color: rgba(127, 53, 153, 0.07);
  text-transform: uppercase;
}
</style>
